// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__z0GLG","loader":"Loader_loader__fQH20"};